import React, {CSSProperties} from 'react';
import {Location} from "../../types/location";
import {Mode} from "../../enum/mode";
import {useTranslation} from "../../hooks/useTranslation";

type LocationToolTipProps = {
    location: Location,
    mode: Mode
}

export function LocationToolTip({location, mode} : LocationToolTipProps) {
    const translate = useTranslation();

    const locationToolTipStyling : CSSProperties = {
        position: 'absolute',
        transformOrigin: 'bottom',
        transform: 'translate(-50%, calc(-100% - 60px))',
        minWidth: '280px',
        backgroundColor: 'transparent',
        paddingBottom: '10px',
        top: '5px',
        zIndex: 1
    };

    const locationTitleBoxStyling : CSSProperties = {
        padding: '15px 20px',
        boxShadow: '3px 3px 20px #0000001A',
        backgroundColor: '#fff',
        border: '1px solid #DFDFDF',
        fontSize: 16,
        fontWeight: 'bold'
    };

    return (
        <span style={locationToolTipStyling} className={'mapToolTip'}>
            <div style={locationTitleBoxStyling}>
                    {mode !== Mode.SINGLE ?
                        <a href={location.detail}><span className={'locationName'}>{location.name}</span></a>
                        :
                        <span className={'locationName'}>{location.name}</span>
                    }
            </div>
        </span>
    );
}
